import React from 'react';
import { Menu } from 'antd';
import { NavLink, useRouteMatch } from 'react-router-dom';
import FeatherIcon from 'feather-icons-react';
import propTypes from 'prop-types';
import Cookies from 'js-cookie';

const { SubMenu } = Menu;

const MenuItems = ({ darkMode, toggleCollapsed, topMenu }) => {
  const roleType = JSON.parse(Cookies.get('logedIn'));
  const { path } = useRouteMatch();

  const pathName = window.location.pathname;
  const pathArray = pathName.split(path);
  const mainPath = pathArray[1];
  const mainPathSplit = mainPath.split('/');
  const [openKeys, setOpenKeys] = React.useState(
    !topMenu ? [`${mainPathSplit.length > 2 ? mainPathSplit[1] : 'dashboard'}`] : [],
  );

  const onOpenChange = (keys) => {
    setOpenKeys(keys[keys.length - 1] !== 'recharts' ? [keys.length && keys[keys.length - 1]] : keys);
  };

  const onClick = (item) => {
    if (item.keyPath.length === 1) setOpenKeys([]);
  };

  return (
    <Menu
      onOpenChange={onOpenChange}
      onClick={onClick}
      mode={!topMenu || window.innerWidth <= 991 ? 'inline' : 'horizontal'}
      theme={darkMode && 'dark'}
      // // eslint-disable-next-line no-nested-ternary
      defaultSelectedKeys={
        !topMenu
          ? [
              `${
                mainPathSplit.length === 1 ? 'home' : mainPathSplit.length === 2 ? mainPathSplit[1] : mainPathSplit[2]
              }`,
            ]
          : []
      }
      defaultOpenKeys={!topMenu ? [`${mainPathSplit.length > 2 ? mainPathSplit[1] : 'dashboard'}`] : []}
      overflowedIndicator={<FeatherIcon icon="more-vertical" />}
      openKeys={openKeys}
    >
      <Menu.Item key="home">
        <NavLink onClick={toggleCollapsed} to={`${path}`}>
          Dashboard
        </NavLink>
      </Menu.Item>
      {roleType.role === 'superadmin' ? (
        <SubMenu key="adminUsers" icon={!topMenu && <FeatherIcon icon="users" />} title="Admin Users">
          <Menu.Item key="user-dataTable">
            <NavLink onClick={toggleCollapsed} to={`${path}/users/dataTable`}>
              Users Listing
            </NavLink>
          </Menu.Item>
        </SubMenu>
      ) : null}
      <SubMenu key="communityUsers" icon={!topMenu && <FeatherIcon icon="users" />} title="Community Users">
        <Menu.Item>
          <NavLink onClick={toggleCollapsed} to={`${path}/customer/grid-style`}>
            User Grid
          </NavLink>
        </Menu.Item>
        <Menu.Item>
          <NavLink onClick={toggleCollapsed} to={`${path}/post/listing`}>
            Post Listing
          </NavLink>
        </Menu.Item>
        <Menu.Item>
          <NavLink onClick={toggleCollapsed} to={`${path}/question/listing`}>
            Question Listing
          </NavLink>
        </Menu.Item>
        <Menu.Item>
          <NavLink onClick={toggleCollapsed} to={`${path}/question/report`}>
            Report Question Listing
          </NavLink>
        </Menu.Item>
        <Menu.Item>
          <NavLink onClick={toggleCollapsed} to={`${path}/banner/listing`}>
            Banner
          </NavLink>
        </Menu.Item>
        <Menu.Item>
          <NavLink onClick={toggleCollapsed} to={`${path}/bannerImage/listingImage`}>
            Banner Image
          </NavLink>
        </Menu.Item>
        <Menu.Item>
          <NavLink onClick={toggleCollapsed} to={`${path}/stack/listStack`}>
            Stacks
          </NavLink>
        </Menu.Item>
        <Menu.Item>
          <NavLink onClick={toggleCollapsed} to={`${path}/brand/listBrand`}>
            Brands
          </NavLink>
        </Menu.Item>
      </SubMenu>
    </Menu>
  );
};

MenuItems.propTypes = {
  darkMode: propTypes.bool,
  topMenu: propTypes.bool,
  toggleCollapsed: propTypes.func,
};

export default MenuItems;
